export const iconFontAwesomeBuildingsHouseFlag = (
	<i className="fa-solid fa-house-flag"></i>
);
